import { useTranslation } from 'react-i18next'
import { useMatches } from 'react-router-dom'
import { Language } from '../types/user/User'
import { RouteHandle } from '../routes/Route'

export const useDocsURL = () => {
  const { i18n } = useTranslation()
  const { language } = i18n

  // Every language has its own path on the docs site, e.g. https://docs.finadeck.com/fi/manual/…
  switch (language) {
    case Language.fi:
      return `${process.env.REACT_APP_DOCS_BASE_URL}fi/`
    case Language.sv:
      return `${process.env.REACT_APP_DOCS_BASE_URL}sv/`
    case Language.en:
    default:
      return `${process.env.REACT_APP_DOCS_BASE_URL}en/`
  }
}

/** Manual page of the current route, inherited from the closest parent route that has one. */
export const usePageDocsURL = () => {
  const docsURL = useDocsURL()
  const matches = useMatches()
  const docsPath = [...matches]
    .reverse()
    .map(match => (match.handle as RouteHandle | undefined)?.docsPath)
    .find(Boolean)

  return docsPath ? `${docsURL}${docsPath}` : docsURL
}

export const useIntegrationDocsURL = () => {
  const docsBaseURL = useDocsURL()

  return {
    accounting: (integrationName: string) =>
      `${docsBaseURL}manual/businesses/integrations/accounting/${integrationName}`,
    external: (integrationName: string) => `${docsBaseURL}manual/businesses/integrations/other/${integrationName}`,
    manual: (integrationName: string) => `${docsBaseURL}manual/businesses/integrations/manual/${integrationName}`
  }
}

export const useWordpressURL = () => {
  const { i18n } = useTranslation()
  const { language } = i18n

  switch (language) {
    case Language.sv:
      return 'https://finadeck.fi/sv/'
    case Language.en:
      return 'https://finadeck.fi/en/'
    case Language.fi:
    default:
      return 'https://finadeck.fi/'
  }
}
